import { useState } from 'react'
import { SystemSS } from '../../../components/SystemSS'
import { FullScreenModal } from '../../../utility/FullScreenModal'

export const FacilitiesTitles = () => {
    const [showModal, setShowModal] = useState(false)
    const [modalContent, setModalContent] = useState({ contentType: '', category: '', index: 1 })
    const handleOpenModal = (contentType, category, index, maxIndex) => {
        setModalContent({ contentType, category, index, maxIndex })
        setShowModal(true)
    }
    const handleCloseModal = () => {
        setModalContent({ contentType: '', category: '', index: 0 })
        setShowModal(false)
    }
    return (
        <>
            <section className=''>
                <div className='flex justify-center '>
                    <img
                        className=''
                        alt='titles'
                        src={`${process.env.PUBLIC_URL}/images/system/system-titles-fr.webp`}
                    />
                </div>
                <div className='text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full md:w-4/5 px-4 md:px-0 mx-auto mt-12'>
                    <p>
                        Les <span className='text-pborange'>Titres</span> sont des étiquettes transférables qui
                        affectent l'état d'une unité. Chaque <span className='text-pborange'>unité </span> ou
                        <span className='text-pborange'> objet</span> possède un Titre dès le départ, et chaque Titre a
                        des effets différents. Vous pouvez attribuer des Titres à votre guise. Par conséquent, si vous
                        obtenez un objet doté d'un Titre puissant, veillez à essayer de le transférer à quelque chose
                        d'autre !{' '}
                    </p>
                    <SystemSS
                        mediaItems={[
                            {
                                modalId: 'titles',
                                index: 1,
                            },
                        ]}
                        handleOpenModal={handleOpenModal}
                        description="Attribuez des Titres puissants pour bénéficier d'augmentations de statistiques diverses et puissantes !"
                    />
                    <p>
                        Les Titres peuvent également être accordés aux <span className='text-pborange'>donjons</span>{' '}
                        que vous créez. Quand vous attribuez un Titre à un donjon, chacun des niveaux que vous terminez{' '}
                        <span className='text-pborange'>augmentera les statistiques de ce Titre</span> ! Triomphez de
                        donjons aléatoires pour renforcer vos Titres, que vous pourrez alors utiliser pour améliorer vos
                        unités et vos objets !
                    </p>{' '}
                    <SystemSS
                        mediaItems={[
                            {
                                modalId: 'titles',
                                index: 2,
                            },
                        ]}
                        handleOpenModal={handleOpenModal}
                        description="Quand vous accordez un Titre à un donjon, tous les monstres du donjon bénéficient également de ce Titre. Veillez à vous préparer pour des batailles difficiles si vous décidez d'attribuer un Titre puissant !"
                    />{' '}
                </div>
            </section>
            <FullScreenModal
                showModal={showModal}
                modalContent={modalContent}
                setModalImage
                handleCloseModal={handleCloseModal}
                setModalContent={setModalContent}
                maxIndex={2}
            />
        </>
    )
}
